import React from 'react';
export function Hero() {
  return <section className="pt-[60px] pb-[50px] md:pt-[70px] md:pb-[60px] bg-gradient-to-b from-cream to-cream-dark relative overflow-hidden" data-id="element-176">
      {/* Background glow */}
      <div className="absolute -top-[150px] -right-[120px] w-[500px] h-[500px] bg-[radial-gradient(circle,rgba(184,137,75,0.18)_0%,transparent_70%)] rounded-full pointer-events-none" data-id="element-177" />

      <div className="container-wide" data-id="element-178">
        <div className="flex flex-col items-center text-center relative z-10 max-w-[720px] mx-auto" data-id="element-179">
          <div className="hero-animate-title" data-id="element-180">
            <h1 className="text-[clamp(38px,5.8vw,64px)] mb-5 leading-[1.05]" data-id="element-181">
              Dejá de trabajar{' '}
              <span className="text-gold-dark relative inline-block" data-id="element-182">
                el síntoma
              </span>
              . Entendé por fin{' '}
              <span className="text-gold-dark relative inline-block" data-id="element-183">
                el <span className="highlight-keyword" data-id="element-184">origen</span>
              </span>
              .
            </h1>

            <p className="font-serif text-[clamp(17px,2vw,20px)] text-gold-dark italic font-medium mb-8" data-id="element-185">
              El primer sistema en español para trazar el{' '}
              <span className="highlight-keyword" data-id="element-186">origen generacional</span> de
              tus <span className="highlight-keyword" data-id="element-187">patrones</span>.{' '}
              <strong data-id="element-188">Sola, en privado y con base científica.</strong>
            </p>
          </div>

          {/* Mockup image between subtitles */}
          <div className="w-full max-w-[680px] mx-auto mb-8 hero-animate-image" data-id="element-189">
            <div className="aspect-[4/3] rounded-[20px] shadow-deep relative overflow-hidden group" data-id="element-190">
              <img src="https://cdn.magicpatterns.com/uploads/nJWwK6NYhugm2RGEntFDpd/comprimida.webp" alt="El Origen de Tus Bloqueos - Mockup del sistema" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" width={680} height={510} fetchPriority="high" loading="eager" decoding="async" data-id="element-191" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent pointer-events-none" data-id="element-192" />
              <div className="absolute bottom-5 right-5 bg-gold text-ink px-3.5 py-2 rounded-full text-[11px] font-semibold tracking-[0.08em] font-sans uppercase shadow-lg" data-id="element-193">
                ★ Sistema Completo
              </div>
            </div>
          </div>

          <div className="hero-animate-content" data-id="element-194">
            <p className="text-[17px] text-ink-soft mb-7 leading-relaxed" data-id="element-195">
              Si la terapia y la meditación no alcanzan, y el{' '}
              <span className="highlight-keyword" data-id="element-196">patrón</span> se repite —{' '}
              <strong data-id="element-197">no estás fallando</strong>. Estás trabajando el síntoma
              sin conocer la <span className="highlight-keyword" data-id="element-198">raíz</span>.
            </p>

            <div className="flex flex-wrap justify-center gap-2 mb-7" data-id="element-199">
              <span className="bg-white border border-border px-3.5 py-1.5 rounded-full text-[13px] text-ink font-medium" data-id="element-200">
                📘 100% Digital
              </span>
              <span className="bg-white border border-border px-3.5 py-1.5 rounded-full text-[13px] text-ink font-medium" data-id="element-201">
                ⚡ Acceso en 5 min
              </span>
              <span className="bg-white border border-border px-3.5 py-1.5 rounded-full text-[13px] text-ink font-medium" data-id="element-202">
                🔒 Privado · A tu ritmo
              </span>
              <span className="bg-white border border-border px-3.5 py-1.5 rounded-full text-[13px] text-ink font-medium" data-id="element-203">
                🧬 Con base científica
              </span>
            </div>

            <a href="#oferta" className="inline-flex items-center gap-2.5 bg-ink text-cream px-8 py-4 rounded-full no-underline text-base font-semibold shadow-deep transition-all duration-250 hover:bg-rust hover:-translate-y-0.5 group border-none cursor-pointer tracking-[0.01em]" data-id="element-204">
              Quiero entender el origen
              <span className="transition-transform duration-250 group-hover:translate-x-1" data-id="element-205">
                →
              </span>
            </a>

            <div className="flex flex-wrap justify-center gap-3.5 mt-4 text-[13px] text-ink-soft" data-id="element-206">
              <span className="inline-flex items-center gap-1.5" data-id="element-207">
                🛡️ Garantía 7 días
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-208">
                🔒 Pago seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-209">
                💳 Mercado Pago
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}